<template>
    <div class="py-10">
        <header>
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h2 class="py-0.5 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                            {{ $t('My products') }}
                        </h2>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-10 my-6 bg-white shadow overflow-hidden sm:rounded-md">
                    <loading :status="loading"/>
                    <template v-if="products.length > 0">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                            <tr>
                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Name') }}
                                </th>
                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Serial number') }}
                                </th>
                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Category') }}
                                </th>
                                <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                                    {{ $t('Support') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="product in products" :key="product.id">
                                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-900">
                                    {{ product.name }}
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                                    {{ product.serial_number }}
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                                    {{ product.category ? product.category.name : '—' }}
                                </td>
                                <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5">
                                    <span v-if="product.support_expiration_date && isExpired(product.support_expiration_date)" class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full bg-red-100 text-red-800">
                                        {{ $t('Expired') }}
                                    </span>
                                    <span v-else-if="product.support_expiration_date" class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full bg-green-100 text-green-800">
                                        {{ product.support_expiration_date }}
                                    </span>
                                    <span v-else class="text-gray-400">—</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-else-if="!loading">
                        <div class="h-full flex">
                            <div class="m-auto">
                                <div class="grid grid-cols-1 justify-items-center h-full w-full py-24">
                                    <div class="flex justify-center items-center">
                                        <svg-vue class="h-full h-auto w-48 mb-6" icon="undraw.task-list"></svg-vue>
                                    </div>
                                    <div class="flex justify-center items-center">
                                        <div class="w-full font-semibold text-2xl">{{ $t('No records found') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    name: "products-list",
    metaInfo() {
        return {
            title: this.$i18n.t('My products')
        }
    },
    data() {
        return {
            loading: true,
            products: [],
        }
    },
    mounted() {
        this.getProducts();
    },
    methods: {
        getProducts() {
            const self = this;
            self.loading = true;
            axios.get('api/tickets/products').then(function (response) {
                self.products = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        isExpired(date) {
            return new Date(date) < new Date();
        }
    }
}
</script>
